import PageHeader from "../components/sections/PageHeader";
import ProductsShowcase from "../components/sections/ProductsShowcase";
import CTASection from "../components/sections/CTASection";
import EditorialMarquee from "../components/sections/EditorialMarquee";
import { Reveal } from "../components/motion";
import { Eyebrow } from "../components/CTA";
import { INDUSTRIES } from "../lib/site";
import Seo from "../components/Seo";

const Products = () => {
  return (
    <div data-testid="products-page">
      <Seo
        title="Products"
        description="PAHI TECHNOCRATE products: HVAC parts & ducting, electrical panels, MCB boxes, server racks, E-Rickshaw chassis, inverter boxes, brass bushes, cutting & bending tools, fire-rated & stainless steel doors, drains and chimneys — custom OEM manufacturing."
        path="/products"
      />
      <PageHeader
        eyebrow="Our Products"
        crumb="Products"
        titleLines={["Products engineered", <span key="p" className="text-brand-soft">to perform.</span>]}
        subtitle="From HVAC parts and electrical enclosures to precision machined components and industrial doors — manufactured to exacting standards for OEMs across industries."
      />

      <ProductsShowcase />

      <EditorialMarquee dark />

      <section className="bg-white py-20 sm:py-24">
        <div className="mx-auto max-w-[1400px] px-5 text-center sm:px-8">
          <div className="flex justify-center"><Eyebrow>Industries We Serve</Eyebrow></div>
          <h2 className="mt-5 font-display text-3xl font-medium tracking-tight text-navy sm:text-4xl">
            Trusted across sectors.
          </h2>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
            {INDUSTRIES.map((ind, i) => (
              <Reveal key={ind} delay={i * 0.04}>
                <span className="rounded-full border border-navy/15 bg-surface px-6 py-3 font-display text-base font-medium text-navy">
                  {ind}
                </span>
              </Reveal>
            ))}
          </div>
          <p className="mx-auto mt-10 max-w-2xl text-slate-500">
            Don't see your product? We specialise in custom OEM manufacturing — share your drawings and we'll engineer it to spec.
          </p>
        </div>
      </section>

      <CTASection />
    </div>
  );
};

export default Products;
